import { render, staticRenderFns } from "./CatHeader.vue?vue&type=template&id=3392dc87&scoped=true"
import script from "./CatHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CatHeader.vue?vue&type=style&index=0&id=3392dc87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392dc87",
  null
  
)

export default component.exports